import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex, Input, TreeSelect, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getMyInfo, getRoleInfo, rolesAction } from 'src/store/Slices/AuthSlice';
import { getFormViews } from 'src/store/Slices/DropDownSlice';
const { SHOW_PARENT } = TreeSelect;

const AddEditRolesModal = ({ visible, setVisible, roleInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [name, setName] = useState()
    const [alias, setAlias] = useState()
    const [description, setDescription] = useState()
    const [formViews, setFormViews] = useState()

    const formViewsOptions = useSelector(state => state.DropDownSlice.formViews)
    const roleInfos = useSelector(state => state.AuthSlice.roleInfo)


    useEffect(() => {
        setName()
        setAlias()
        setDescription()
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            let arr = []
            for (let index = 0; index < roleInfos?.data?.value?.formViews.length; index++) {
                arr.push(roleInfos?.data?.value?.formViews[index].id)
            }
            setName(roleInfo?.name)
            setAlias(roleInfo?.alias)
            setDescription(roleInfo?.description)
            setFormViews(arr)
        }
    }, [visible, roleInfo, roleInfos])

    useEffect(() => {
        if (visible.flag === 'edit') {
            !formViewsOptions && dispatch(getFormViews())
            dispatch(getRoleInfo({id: roleInfo.id}))
        }
    }, [visible.flag])

    const onClickSubmit = () => {
        dispatch(rolesAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: {
                id: visible.flag !== 'add' ? roleInfo.id : undefined,
                name: name,
                alias: alias,
                description: description,
                formViews : formViews
            }
        })).then(() => {
            dispatch(rolesAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
            })
            dispatch(getMyInfo({ username: localStorage.getItem('username') }))
        })
    }

    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить роль' : 'Редактировать роль'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Название</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Алиас</Typography.Title>
                            <Input
                                value={alias}
                                onChange={e => setAlias(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Описание</Typography.Title>
                            <Input
                                value={description}
                                onChange={e => setDescription(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Права</Typography.Title>
                            <TreeSelect
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Выбрать"
                                allowClear
                                multiple
                                value={formViews}
                                onChange={setFormViews}
                                treeData={formViewsOptions?.data?.value}
                                onClick={() => { visible.flag === 'add' && dispatch(getFormViews()) }}
                                maxTagCount={0}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditRolesModal